// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"308cbe95","213":"95693cb1","426":"d6e1fdb5","522":"2c241ad5","732":"b7bc9e7f","965":"3b79472b"}[chunkId] + ".chunk.js";
};